/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cv_picker_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a color`)
};

const es_cv_picker_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige un color`)
};

const de_cv_picker_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbe auswählen`)
};

const nl_cv_picker_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een kleur`)
};

const fr_cv_picker_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir une couleur`)
};

const it_cv_picker_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli un colore`)
};

const pt_br2_cv_picker_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolher uma cor`)
};

const pt_cv_picker_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha uma cor`)
};

const ja_cv_picker_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`色を選択する`)
};

const zh_cv_picker_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择颜色`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cv_picker_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cv_picker_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cv_picker_label", locale)
	if (locale === "en") return en_cv_picker_label(inputs)
	if (locale === "es") return es_cv_picker_label(inputs)
	if (locale === "de") return de_cv_picker_label(inputs)
	if (locale === "nl") return nl_cv_picker_label(inputs)
	if (locale === "fr") return fr_cv_picker_label(inputs)
	if (locale === "it") return it_cv_picker_label(inputs)
	if (locale === "pt-BR") return pt_br2_cv_picker_label(inputs)
	if (locale === "pt") return pt_cv_picker_label(inputs)
	if (locale === "ja") return ja_cv_picker_label(inputs)
	return zh_cv_picker_label(inputs)
};